import { useTranslation } from "react-i18next";

const finalCtaBg =
  "https://readdy.ai/api/search-image?query=Modern%20luxury%20residence%20at%20night%20with%20warm%20interior%20lighting%20glowing%20through%20large%20windows%2C%20contemporary%20steel%20frame%20architecture%2C%20landscaped%20garden%20with%20subtle%20pathway%20lighting%2C%20premium%20architectural%20photography%2C%20warm%20ambient%20tones%2C%20cream%20and%20charcoal%20color%20palette%2C%20editorial%20quality%20with%20soft%20dark%20background&width=1600&height=650&seq=13&orientation=landscape";

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={finalCtaBg} alt="現代住宅夜景" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-graphite/85 via-graphite/70 to-graphite/85" />
      </div>

      <div className="relative z-10 section-padding">
        <div className="container-main text-center max-w-3xl mx-auto">
          <span className="tag-label mb-6 inline-block">{t("portfolio.final.label")}</span>
          <h2 className="text-white mb-8">{t("portfolio.final.title")}</h2>
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary gap-2 inline-flex"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            {t("portfolio.final.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}